/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'
import { Grow, IconButton, InputAdornment } from '@mui/material';
import splash from './splashscreen.jpg';
import { Formik, Form, } from 'formik'
import TextField from './../formik/TextField'
import * as Yup from "yup";
import MikeButton from '../mike-button/MikeButton';
import { useAppDispatch } from '../../store/store';
import { userSet } from '../../reducers/auth';
import { ILoginPayload, useLoginMutation } from '../../apis/apiSlice';
import { jwtDecode } from "jwt-decode"
import IJwtToken, { Email, FirstName, Role } from '../../model/IJwtToken';
import { errorAdded } from '../../reducers/toast';
import { useState } from 'react';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';

interface IValue {
  email: string; 
  password: string; 
}

  const validationSchema = Yup.object().shape({ 
    email: Yup.string().email("E-Mail-Adresse ist erforderlich").required("E-Mail-Adresse ist erforderlich"),
    password: Yup.string().required("Passwort ist erforderlich")
  });

const LandingPageStyle =  css`  
  background-repeat: no-repeat;
  background-size: 100% 100%;
  height: calc(100vh - 60px);
  width: 100vw;
  position: relative;
  background-image: url(${splash});
  `; 


const LandingPageContentStyle =  css`
  background: white; 
  position: fixed;
  left: 50%;
  top: 50%; 
  width: 538px;
  height: 300px;
  margin: auto;
  margin-left: -269px;
  margin-top: -150px;
 `;


const wrapperStyle = 
  css`
    padding: 50px 40px 25px 40px;
  `;

const buttonContainerStyle = 
css`
  display: flex;
  align-items: center;
  justify-content: center;
`;

const LandingPage = () => {

  const dispatch = useAppDispatch()
  const [login, { isLoading: loggingIn} ] = useLoginMutation();

  const [showPassword, setShowPassword] = useState(false);
  const handleClickShowPassword = () => setShowPassword(!showPassword);
  const handleMouseDownPassword = () => setShowPassword(!showPassword);
 
  const onSubmit = async (values: IValue) => { 
    const payload = {password: values.password, login: values.email} as ILoginPayload
    try{
      const response = await login(payload).unwrap();
      if (response && response.token){
        const token = response.token
        const decoded = jwtDecode<IJwtToken>(token);
        if (decoded){
          const name = decoded[FirstName]         
          dispatch(userSet({email: decoded[Email], name: name, role: decoded[Role], token}))
        }
      }
      else{
        dispatch(errorAdded(["Die Anmeldung ist fehlgeschlagen. Bitte überprüfen Sie E-Mail-Adresse und Passwort."]))
      }      
    }
    catch(error){
      dispatch(errorAdded(["Die Anmeldung ist fehlgeschlagen. Bitte überprüfen Sie E-Mail-Adresse und Passwort."]))
    }
  } 

  return (     
    <div css={LandingPageStyle}> 
      <div css={LandingPageContentStyle}>
        <Grow in={true}>
          <div css={wrapperStyle}>            
            <Formik
              validationSchema={validationSchema}
              initialValues={ {  email: "", password: ""}}
              enableReinitialize     
              onSubmit={onSubmit}>
                {(formikProps) => {
                  const { handleChange, setFieldTouched, handleSubmit, isValid } = formikProps
                          
                  const handleOnChange = (name, e) => {
                    // e.persist()
                    handleChange(e)
                    setFieldTouched(name, true, false)              
                  } 

                  return (           
                    <Form>  
                      <TextField
                        onChange={handleOnChange.bind(null, 'email')}
                        name='email'        
                        label={'E-Mail-Adresse'}                                        
                        addPlaceHolder={true}
                        fullWidth
                      />  
                      <TextField
                        type={showPassword ? "text" : "password"} 
                        onChange={handleOnChange.bind(null, 'password')}
                        name='password'        
                        label={'Passwort'}                                        
                        addPlaceHolder={true}
                        fullWidth
                        slotProps={{input: {endAdornment: (
                          <InputAdornment position="end">
                            <IconButton
                              aria-label="toggle password visibility"
                              onClick={handleClickShowPassword}
                              onMouseDown={handleMouseDownPassword}
                            >
                              {showPassword ? <VisibilityIcon /> : <VisibilityOffIcon />}
                            </IconButton>
                          </InputAdornment>
                        )}}}
                      /> 
                      <div css={buttonContainerStyle}>
                        <MikeButton variant="contained" disabled={!isValid} id="loginButton" onClick={() => handleSubmit()} active={loggingIn}>
                          {'Anmelden mit E-Mail-Adresse'}               
                        </MikeButton> 
                      </div>                        
                    </Form>
                  )
                }
              }
            </Formik>     
          </div>
        </Grow>
      </div>
    </div>
  );
};

export default LandingPage;
